import { useInfiniteQuery } from '@tanstack/react-query'
import _ from 'lodash'

import { getPastAppointments } from 'services/graphQLCloudService'
import filterAndProcessAppointments from 'helpers/apptsFilterUtils'
import { appointmentsKeys } from './keys'
import { getPastAppointmentsNextPageParam } from './getPastAppointmentsNextPageParam'
import { APPOINTMENTS_RETRY } from './retry'

const fetchAndProcessPastAppointmentsPage = async ({
  patientId,
  token,
  nextUrl,
  dependentAccount
}) => {
  const data = await getPastAppointments(patientId, token, nextUrl)
  const rawAppointments = _.get(data, 'appointmentPast.appointments', [])
  const processed = filterAndProcessAppointments(
    rawAppointments,
    'appointmentPast',
    dependentAccount
  )
  const sorted = _.orderBy(processed, ['datetime'], ['desc'])
  const outputNextUrl = _.get(data, 'appointmentPast.nextUrl', null)

  return {
    appointments: sorted,
    nextUrl: outputNextUrl
  }
}

export const useGetPastAppointments = ({
  patientId,
  token,
  dependentAccount = null,
  useQueryOptions = {}
}) => {
  return useInfiniteQuery({
    queryKey: appointmentsKeys.past(patientId, dependentAccount),
    queryFn: ({ pageParam }) =>
      fetchAndProcessPastAppointmentsPage({
        patientId,
        token,
        nextUrl: pageParam,
        dependentAccount
      }),
    initialPageParam: null,
    getNextPageParam: getPastAppointmentsNextPageParam,
    enabled: Boolean(patientId),
    staleTime: 30_000,
    refetchOnMount: false,
    retryOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    ...APPOINTMENTS_RETRY,
    ...useQueryOptions
  })
}
